import {Select as AntSelect} from "antd";

export const Select = AntSelect;
export default Select;
